<div
  class="category-menu flex h-[400px] space-x-10 rounded-md bg-white p-3 text-primary-darkest shadow-md">
  <div class="main-category h-full w-[300px] overflow-y-auto px-2">
    <ul class="grid capitalize">
      <li
        *ngFor="let category of categories"
        class="flex cursor-pointer items-center justify-between border-b border-primary-main p-2 hover:rounded-lg hover:bg-primary-light"
        [ngClass]="{
          'bg-primary-lightest': category.name == parentCategory.name
        }"
        (click)="selectCategoryParent(category)">
        <span>{{ category.name }}</span>
        <fa-icon *ngIf="category.children[0]" [icon]="faAngleRight"></fa-icon>
      </li>
    </ul>
  </div>
  <div class="min-h-full w-full overflow-y-auto">
    <div class="sub-category columns-3 overflow-y-auto">
      <ng-container *ngFor="let category2 of childrenCategories">
        <div class="sub-category__parent mb-5 break-inside-avoid">
          <a
            class="mb-2 block cursor-pointer font-bold uppercase"
            (click)="selectCategory(category2)">
            {{ category2.name }}
          </a>
          <ul class="capitalize" *ngIf="category2.children">
            <li
              class="cursor-pointer hover:text-primary-md-dark"
              *ngFor="let category3 of category2.children"
              (click)="selectCategory(category2, category3)">
              {{ category3.name }}
            </li>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>
</div>
